<template>
    <div class="relative">
        <div class="open-vacancies">
            <div class="bg-ice-blue card-border-radius">
                <div class="card-vacancies py-3">
                    <div class="pb-3 text-light-blue-pc4">
                        {{tags.title}}
                    </div>
                    <div class="my-2">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.4274 19.807L21.0095 14.8125V3.9375C21.0095 3.52266 20.6743 3.1875 20.2595 3.1875H3.75947C3.34463 3.1875 3.00947 3.52266 3.00947 3.9375V14.8125L1.59151 19.807C1.41572 20.2969 1.77666 20.8125 2.29697 20.8125H21.722C22.2423 20.8125 22.6032 20.2969 22.4274 19.807ZM4.69697 4.875H19.322V14.1328H4.69697V4.875ZM10.0478 19.125L10.2376 18.2578H13.7603L13.9501 19.125H10.0478ZM15.2978 19.125L14.8501 17.093C14.8313 17.0062 14.754 16.9453 14.6673 16.9453H9.33291C9.24385 16.9453 9.16885 17.0062 9.1501 17.093L8.70244 19.125H3.53916L4.53057 15.6328H19.4884L20.4798 19.125H15.2978Z" fill="#4D4D4D"/></svg>
                            <div>
                                {{tags.exp}}
                            </div>
                        </div>
                        <div >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6134 7.16667C12.6134 6.98986 12.5431 6.82029 12.4181 6.69526C12.2931 6.57024 12.1235 6.5 11.9467 6.5C11.7699 6.5 11.6003 6.57024 11.4753 6.69526C11.3503 6.82029 11.28 6.98986 11.28 7.16667V12.98L15.2134 15.6467C15.2858 15.7012 15.3686 15.7403 15.4567 15.7617C15.5448 15.7831 15.6364 15.7863 15.7257 15.7711C15.8151 15.756 15.9005 15.7227 15.9766 15.6734C16.0526 15.6241 16.1179 15.5598 16.1683 15.4845C16.2187 15.4091 16.2532 15.3242 16.2696 15.2351C16.2861 15.1459 16.2843 15.0544 16.2641 14.966C16.244 14.8776 16.2061 14.7942 16.1526 14.721C16.0992 14.6477 16.0314 14.5861 15.9534 14.54L12.62 12.28L12.6134 7.16667Z" fill="#4D4D4D"/><path d="M22.08 8.53986C21.6749 8.72536 21.2466 8.85542 20.8067 8.92653C21.5102 10.9295 21.5125 13.112 20.8131 15.1164C20.1137 17.1207 18.7542 18.8281 16.9574 19.9586C15.1605 21.0891 13.033 21.5757 10.9233 21.3387C8.81372 21.1016 6.8472 20.1549 5.34609 18.6538C3.84497 17.1527 2.89831 15.1862 2.66124 13.0766C2.42417 10.9669 2.91077 8.83937 4.04128 7.04253C5.17179 5.24569 6.87915 3.88617 8.88354 3.1868C10.8879 2.48743 13.0704 2.48968 15.0734 3.19319C15.1445 2.75331 15.2745 2.32501 15.46 1.91986C13.1709 1.12833 10.681 1.13638 8.39703 1.94269C6.11305 2.749 4.16996 4.30591 2.8851 6.35916C1.60024 8.41241 1.04955 10.8406 1.32297 13.2473C1.59638 15.6539 2.67774 17.8968 4.39044 19.6095C6.10314 21.3222 8.34597 22.4035 10.7526 22.6769C13.1593 22.9503 15.5875 22.3997 17.6407 21.1148C19.694 19.8299 21.2509 17.8868 22.0572 15.6029C22.8635 13.3189 22.8716 10.829 22.08 8.53986Z" fill="#4D4D4D"/><path d="M12 4.25342C10.0905 4.25744 8.25057 4.97019 6.83667 6.25352C5.42278 7.53685 4.53564 9.29939 4.34721 11.1995C4.15877 13.0997 4.68245 15.0021 5.81675 16.5381C6.95105 18.0742 8.6152 19.1344 10.4867 19.5134L10.6667 18.4668C9.68711 18.2933 8.75878 17.9029 7.94973 17.3241C7.14067 16.7452 6.47142 15.9927 5.99102 15.1216C5.51063 14.2504 5.23127 13.2829 5.17343 12.2898C5.1156 11.2966 5.28075 10.3032 5.65677 9.38219C6.0328 8.4612 6.61017 7.63604 7.34656 6.9672C8.08295 6.29836 8.95969 5.8028 9.9125 5.51685C10.8653 5.2309 11.87 5.16181 12.853 5.31464C13.836 5.46747 14.7723 5.83835 15.5933 6.40008C15.342 5.93534 15.1665 5.43348 15.0733 4.91342C14.1058 4.48258 13.0591 4.25782 12 4.25342Z" fill="#4D4D4D"/><path d="M20 7.33317C21.8409 7.33317 23.3333 5.84079 23.3333 3.99984C23.3333 2.15889 21.8409 0.666504 20 0.666504C18.159 0.666504 16.6666 2.15889 16.6666 3.99984C16.6666 5.84079 18.159 7.33317 20 7.33317Z" fill="#4D4D4D"/></svg>
                            <div>
                                {{tags.time}}
                            </div>
                        </div>
                        <div >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 2.75C12.75 2.55109 12.671 2.36032 12.5303 2.21967C12.3897 2.07902 12.1989 2 12 2C11.8011 2 11.6103 2.07902 11.4697 2.21967C11.329 2.36032 11.25 2.55109 11.25 2.75V4.5H9.27599C8.92468 4.49984 8.58146 4.60542 8.29099 4.803L6.59599 5.957C6.55438 5.98518 6.50524 6.00016 6.45499 6H2.35299C2.15407 6 1.96331 6.07902 1.82266 6.21967C1.682 6.36032 1.60299 6.55109 1.60299 6.75C1.60299 6.94891 1.682 7.13968 1.82266 7.28033C1.96331 7.42098 2.15407 7.5 2.35299 7.5H3.92999L0.562986 15.18C0.499387 15.3299 0.485463 15.4962 0.523254 15.6545C0.561045 15.8129 0.648564 15.955 0.772986 16.06C0.852986 16.124 0.933986 16.185 1.08199 16.281C1.26799 16.402 1.53399 16.559 1.87399 16.714C2.55399 17.025 3.53599 17.334 4.74999 17.334C5.74201 17.3359 6.72285 17.1245 7.62599 16.714C7.96599 16.559 8.23199 16.402 8.41799 16.281C8.56799 16.184 8.64799 16.123 8.72799 16.058C8.8534 15.9542 8.94163 15.8124 8.97933 15.654C9.01704 15.4956 9.00217 15.3292 8.93699 15.18L5.56899 7.5H6.45499C6.80599 7.5 7.14899 7.394 7.43899 7.197L9.13499 6.043C9.17631 6.01501 9.22507 6.00004 9.27499 6H11.25V20.5H6.76299C6.56407 20.5 6.37331 20.579 6.23266 20.7197C6.092 20.8603 6.01299 21.0511 6.01299 21.25C6.01299 21.4489 6.092 21.6397 6.23266 21.7803C6.37331 21.921 6.56407 22 6.76299 22H17.237C17.4359 22 17.6267 21.921 17.7673 21.7803C17.908 21.6397 17.987 21.4489 17.987 21.25C17.987 21.0511 17.908 20.8603 17.7673 20.7197C17.6267 20.579 17.4359 20.5 17.237 20.5H12.75V6H14.724C14.774 6 14.824 6.015 14.864 6.043L16.561 7.197C16.851 7.394 17.194 7.5 17.545 7.5H18.431L15.063 15.18C14.9956 15.3336 14.9817 15.5053 15.0234 15.6677C15.0651 15.8301 15.16 15.9739 15.293 16.076C15.305 16.085 15.293 16.076 15.295 16.076C15.3942 16.1507 15.4977 16.2195 15.605 16.282C15.79 16.394 16.055 16.538 16.395 16.682C17.2992 17.06 18.27 17.2531 19.25 17.25C20.2304 17.2529 21.2015 17.0594 22.106 16.681C22.444 16.538 22.71 16.394 22.896 16.282C23.0029 16.2189 23.1064 16.1501 23.206 16.076C23.339 15.9739 23.4339 15.8301 23.4756 15.6677C23.5173 15.5053 23.5033 15.3336 23.436 15.18L20.07 7.5H21.648C21.8469 7.5 22.0377 7.42098 22.1783 7.28033C22.319 7.13968 22.398 6.94891 22.398 6.75C22.398 6.55109 22.319 6.36032 22.1783 6.21967C22.0377 6.07902 21.8469 6 21.648 6H17.546C17.4961 5.99996 17.4473 5.98499 17.406 5.957L15.709 4.803C15.4188 4.60561 15.0759 4.50004 14.725 4.5H12.75V2.75ZM2.19299 15.198C2.98009 15.6168 3.85839 15.835 4.74999 15.833C5.64158 15.835 6.51989 15.6168 7.30699 15.198L4.74999 9.368L2.19299 15.198ZM16.703 15.174C16.785 15.214 16.877 15.257 16.978 15.3C17.508 15.523 18.283 15.75 19.25 15.75C20.1316 15.7525 21.0023 15.5556 21.797 15.174L19.25 9.367L16.703 15.174Z" fill="#4D4D4D"/></svg>
                            <div>
                                {{tags.type}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center items-center pb-4">
                    <a class="button-outlined-dark-blue" :href="tags.url">
                        Quero me inscrever!
                    </a>
                </div>
            </div>
        </div>
        <div class="bg-gradient-green-blue" />
    </div>
</template>

<script>

export default {
props:{
    tags:{
        type:Object,
        required:true,
    },
}
}
</script>
<style lang="postcss" scoped>

.card-border-radius {
    border-radius: 5px;
}

.bg-gradient-green-blue {
    left: 10px;
    bottom: 10px;
    z-index: -1;

    @apply absolute bg-red-100 h-full w-full card-border-radius;
}

.open-vacancies {
    border-radius: 10px;
    min-height: 150px;
}

@media (max-width: 1024px) {
    .card-vacancies svg {
        display: none;
    }
}


.card-vacancies> :first-child {
    display: flex;
    font-size: 32px;
    align-items: center;
    justify-content: center;
    padding: 0 8px 0 8px;
    text-align: center;
}

.card-vacancies {
    border-radius: 10px;
    color: #4D4D4D;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.card-vacancies> :last-child, .card-vacancies> :last-child > * {
    display: flex;
    align-items: center;
    justify-content: center;


    @apply text-center md:text-left px-3;
}

.card-vacancies svg {
    margin-right: 10px;
    color: #4D4D4D;
}

.card-vacancies > :last-child> :not(:first-child) {
    @apply pl-2;
}

.card-vacancies > :last-child> :not(:last-child) {
    border-right: 1px solid #4D4D4D;
    @apply pr-2;
}
</style>
